import { render } from "./red5.vue?vue&type=template&id=02d029a6&scoped=true"
import script from "./red5.vue?vue&type=script&lang=js"
export * from "./red5.vue?vue&type=script&lang=js"

import "./red5.vue?vue&type=style&index=0&id=02d029a6&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d029a6"]])

export default __exports__